import { Theme } from '@mui/material';


const Select = (theme: Theme) => {
  return {
  };
};

export default Select;
